<template>
  <div>
    <big-client-list v-show="tabType === 1" @handleShow="handleShow" />
    <bigClient-show v-if="tabType === 2" :rowId="id" @handleShow="handleShow"/>
  </div>
</template>

<script>
import bigClientList from './list.vue'
import bigClientShow from '../clientList/detail.vue'
export default {
  components: {
    bigClientList,
    bigClientShow
  },
  data() {
    return {
      tabType: 1,
      id: null,
      technicalState: null
    }
  },
  methods: {
    handleShow(id, type) {
      this.tabType = type
      this.id = id
    }
  }
}
</script>

<style>
</style>
